import React from 'react';
import { useGenGridCol } from '../../../../../utils/ComponentHelper';
import { displayAmountCurrying } from '../../../../../utils';
import { useTranslation } from '../../../../../hooks';
import { ExecutionType, Operation } from '../types/OperationDetailsRequestBody';
import { getSwapPathDisplay } from '../utils/getSwapPathDisplay';

interface IProps {
  operationDetails: Operation[];
}

const useSwapDetailsExactGetTable = ({ operationDetails }: IProps) => {
  const { translate } = useTranslation();

  // Exact Get
  const exactGetColumns = [
    // useGenGridCol('operationSequence', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('batchId', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('toAddress', {
    //   minWidth: 350,
    // }),
    useGenGridCol('executionType', {
      minWidth: 250,
    }),
    useGenGridCol('exactGetAmount', {
      minWidth: 140,
    }),
    useGenGridCol('maxPayAmount', {
      minWidth: 140,
    }),

    useGenGridCol('swapPath', {
      minWidth: 250,
    }),
  ];

  const exactGetRows = operationDetails.map((operation: any, index: number) => {
    const toMaxPayDisplayAmount = displayAmountCurrying(
      operation.execution_detail?.decimals_pay || ''
    );
    const toExactGetDisplayAmount = displayAmountCurrying(
      operation.execution_detail?.decimals || ''
    );

    const swapPathDisplay = getSwapPathDisplay(operation.execution_detail?.swap_path || []);

    return {
      id: index,
      operationSequence: operation.operation_seq || '',
      batchId: operation.batch_id || '',
      maxPayAmount: `${toMaxPayDisplayAmount(operation.execution_detail?.amount_pay_max || '')} ${
        operation.execution_detail?.asset_name_pay || ''
      }`,
      exactGetAmount: `${toExactGetDisplayAmount(operation.execution_detail?.amount || '')} ${
        operation.execution_detail?.asset_name || ''
      }`,
      toAddress: operation.execution_detail?.to_address || '',
      executionType:
        translate(`enumConstants.${ExecutionType[operation.execution_detail?.execution_type]}`) ||
        '',
      swapPath: swapPathDisplay,
    };
  });

  return { exactGetColumns, exactGetRows };
};

export default useSwapDetailsExactGetTable;
